import bridge from '@utiles/officialStore/bridge';
import globalConfig from '@utiles/officialStore/globalConfig';
export default {
  data() {
    return {};
  },
  computed: {
    isAutoMatchProduct() {
      return this.$store.state.isAutoMatchProduct;
    },
    isTransparentBgMode() {
      if (!globalConfig.getHrefParam('productId') || !globalConfig.getHrefParam('roleId') || !globalConfig.getHrefParam('roleName') || !globalConfig.getHrefParam('serverId')) {
        return false;
      }
      if (
        globalConfig.getHrefParam('isClearBg') === '1' &&
        bridge.runInsdk() &&
        this.isAutoMatchProduct
      ) {
        return true;
      }
      return false;
    }
  }
};
